export enum StatisticTypeEnum {
    Revenue,
    CountOfChecks,
    AverageCheck,
    MobileApplication,
    GratitudeIndex,
    ComplaintsIndex,
    NonConformityPointsGeneral,
    NonConformityPointsTechnicalCondition,
}
